/**
 * Lahjaopas – hintahaitarit ilman sivulatausta.
 *
 * Hintakortit ovat tavallisia linkkejä (?filter.v.price.gte=…&…lte=…#lahjat),
 * jotka toimivat myös ilman JS:ää. Tämä skripti kaappaa klikkauksen ja ajaa
 * saman päivityksen kuin Horizonin oma suodatinpaneeli:
 * facets-form-component.updateFiltersByURL() → pushState + vain
 * main-collection-osion uudelleenrenderöinti. Ei välkettä, ei koko sivun latausta.
 *
 * Korostus (aktiivinen kortti + Kaikki lahjat) synkronoidaan URL:sta jokaisen
 * filter:update-tapahtuman jälkeen, joten se pysyy oikeana myös kun hintaa
 * muutetaan suodatinpaneelista.
 *
 * Horizon ei käsittele popstatea: takaisin-nappi vaihtaisi URL:n mutta jättäisi
 * vanhan ruudukon. Siksi tämä on moduuli ja renderöi ruudukon itse popstatessa
 * (vain sivuilla, joilla hintahaitarit ovat).
 *
 * Jos facets-komponenttia ei löydy (esim. suodatus pois päältä), linkki
 * toimii normaalisti.
 */
import { sectionRenderer } from '@theme/section-renderer';

var ROOT = '.lahjaopas-tiers';

function parsePrice(value) {
  if (value === null || value === undefined || value === '') return null;
  var n = parseFloat(String(value).replace(',', '.'));
  return isNaN(n) ? null : n;
}

function samePrice(a, b) {
  if (a === null || b === null) return a === b;
  return Math.abs(a - b) < 0.005;
}

function syncActive() {
  var roots = document.querySelectorAll(ROOT);
  if (!roots.length) return;

  var params = new URLSearchParams(window.location.search);
  var min = parsePrice(params.get('filter.v.price.gte'));
  var max = parsePrice(params.get('filter.v.price.lte'));
  var filterActive = min !== null || max !== null;

  roots.forEach(function (root) {
    root.querySelectorAll('.lahjaopas-tier').forEach(function (tier) {
      var active =
        filterActive &&
        samePrice(parsePrice(tier.dataset.min), min) &&
        samePrice(parsePrice(tier.dataset.max), max);
      tier.classList.toggle('lahjaopas-tier--active', active);
      if (active) tier.setAttribute('aria-current', 'true');
      else tier.removeAttribute('aria-current');
    });

    var reset = root.querySelector('.lahjaopas-tiers__reset');
    if (reset) {
      reset.classList.toggle('lahjaopas-tiers__reset--active', !filterActive);
      if (!filterActive) reset.setAttribute('aria-current', 'true');
      else reset.removeAttribute('aria-current');
    }
  });
}

function scrollToGrid(link) {
  var hash = new URL(link.href, window.location.href).hash;
  var anchor = hash ? document.getElementById(hash.slice(1)) : null;
  if (!anchor) return;
  // Rullaa vain jos tuoteruudukon alku on selvästi näkymän alaosassa
  // (mobiili). Desktopilla kortit ja ruudukko näkyvät jo yhdessä.
  if (anchor.getBoundingClientRect().top > window.innerHeight * 0.6) {
    anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

document.addEventListener('click', function (event) {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  var link = event.target.closest(ROOT + ' a.lahjaopas-tier, ' + ROOT + ' a.lahjaopas-tiers__reset');
  if (!link) return;

  var url = new URL(link.href, window.location.href);
  if (url.pathname !== window.location.pathname) return;

  var facets = document.querySelector('facets-form-component');
  if (!facets || typeof facets.updateFiltersByURL !== 'function') return;

  event.preventDefault();
  if (url.search === window.location.search) return;

  facets.updateFiltersByURL(url.toString());
  syncActive();
  scrollToGrid(link);
});

// Suodatinpaneelin muutokset (filter:update kuplii dokumenttiin) ja
// selaimen takaisin/eteenpäin.
document.addEventListener('filter:update', function () {
  setTimeout(syncActive, 0);
});
window.addEventListener('popstate', function () {
  if (!document.querySelector(ROOT)) return;
  var facets = document.querySelector('facets-form-component');
  var sectionId = facets && facets.getAttribute('section-id');
  if (sectionId) sectionRenderer.renderSection(sectionId);
  syncActive();
});
